import fallbackAvatarImage from '@/assets/images/default-avatar.jpg';
import { Button } from '@/components/Button';
import { Image } from '@/components/Image';
import getDefaultCover from '@/utils/getDefaultCover';
import { MdShare } from 'react-icons/md';

interface CardHeaderProps {
  coverImage: string | null;
  avatarImage: string | null;
  onShare: () => void;
  cardColor: string;
}

export const CardHeader = ({
  coverImage,
  avatarImage,
  onShare,
  cardColor,
}: CardHeaderProps) => {
  const defaultCover = getDefaultCover(cardColor);

  return (
    <div className="relative h-[220px] w-full">
      {/* Image de couverture avec effet de fondu */}
      <div className="relative h-[220px] w-full overflow-hidden">
        <Image
          src={coverImage}
          defaultImage={defaultCover}
          alt="Banner"
          className="h-[220px] w-full object-cover"
        />

        {/* Overlay avec dégradé subtil en bas */}
        <div
          className="absolute inset-x-0 bottom-0 h-2/5"
          style={{
            background: `linear-gradient(to bottom, transparent, ${cardColor})`,
          }}
        />
      </div>

      {/* Share Button */}
      <Button
        onClick={onShare}
        className="absolute right-4 top-4 flex size-10 min-w-10 items-center justify-center rounded-full bg-white/90 p-2 text-linko-dark backdrop-blur-sm transition-all hover:scale-105 hover:bg-white"
      >
        <MdShare className="size-5" />
      </Button>

      {/* Profile Picture */}
      <Image
        defaultImage={fallbackAvatarImage}
        src={avatarImage}
        alt="Profile"
        className="absolute bottom-0 left-1/2 size-36 -translate-x-1/2 translate-y-1/2 rounded-full border-4 border-white bg-white object-cover shadow-lg transition-transform"
        isZoomable={true}
      />
    </div>
  );
};
